import {
  ActivationBanner,
  PageBanner,
  QuickTable,
  QuickTableFilterTabs,
} from "../../components";
import { paymentLinkDisplayFormatter } from "./paymentLinksDisplayFormatter";
import { IPaymentLinksViewProps } from "./PaymentLinks";

import linkColoredIcon from "../../assets/icons/link-colored.svg";
import { CreatePaymentLink } from "./CreatePaymentLink";

export const View = (props: IPaymentLinksViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={linkColoredIcon}
        pageTitle={"Payment Links"}
        pageSubtitle={"Receive payments with your payment links"}
        pageDescription={
          "Get started quickly, send payment links to your customers, monitor and receive payments securely."
        }
        linkTitle={"Create your payment link"}
        linkSubtitle={"Create a custom payment page and share a link to it.."}
        linkButtonText={"Create payment link"}
        linkButtonUrl={"create"}
      />

      <ActivationBanner
        title="To create a payment link, you need to activate your profile"
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/profile/activation"
      />

      <QuickTable
        id="paymentLinksTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={paymentLinkDisplayFormatter}
        onExport={props.onExport}
        onCreateNew={props.onCreateNew}
        createNewButtonText={"Create new link"}
      />

      <CreatePaymentLink
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
